import * as fromPcsNotifications from '@app/pcs/shared/notifications/store/reducer/notifications';
import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

export interface State {
  pcsNotificationsState: fromPcsNotifications.State;
}

function notificationsReducer(state, action) {
  return fromPcsNotifications.reducer(state, action);
}

export const reducerForPcsNotifications: ActionReducerMap<State> = {
  pcsNotificationsState: notificationsReducer
};

const pcsNotifications = createFeatureSelector<State>('pcsNotificationsState');

const getPcsNotificationsState = createSelector(
  pcsNotifications,
  (state) => state.pcsNotificationsState
);

export const getNotSeenNewFeaturesNotifications = createSelector(
  getPcsNotificationsState,
  fromPcsNotifications.getNotSeenNewFeatures
);

